import { canonicalString, fiscalDate, fiscalDateTime, formatDocumentNumber, money } from '@makila/fiscal';
export class SeriesError extends Error {
    code;
    constructor(code, message) {
        super(message);
        this.code = code;
        this.name = 'SeriesError';
    }
}
const CODE_RE = /^[A-Z0-9]{1,4}$/;
/** Prefixo da série de um terminal: "VD L1C2 2026" (formação: "VD-FORM L1C2 2026"). */
export function terminalSeriesPrefix(p) {
    for (const c of [p.storeCode, p.terminalCode]) {
        if (!CODE_RE.test(c))
            throw new SeriesError('inactive_code', `Código de loja/terminal inválido: "${c}" (1–4 letras maiúsculas ou algarismos)`);
    }
    const type = p.training ? `${p.docType}-FORM` : p.docType;
    return `${type} ${p.storeCode}${p.terminalCode} ${p.year}`;
}
/** Série nova, vazia. O `seriesId` vem do servidor na activação, ou é gerado no terminal na viragem do ano. */
export function openSeries(p) {
    return {
        seriesId: p.seriesId,
        docType: p.docType,
        year: p.year,
        prefix: terminalSeriesPrefix(p),
        training: p.training,
        nextNumber: 1,
        lastHash: '',
        lastIssueDate: null,
        lastSystemEntry: null,
        keyId: p.keyId,
    };
}
export async function issueInSeries(series, doc, signer) {
    if (signer.keyId !== series.keyId) {
        throw new SeriesError('key_mismatch', `A série ${series.prefix} assina com a chave ${series.keyId}, não com ${signer.keyId}`);
    }
    const issueDate = fiscalDate(doc.now);
    const systemEntryDate = fiscalDateTime(doc.now);
    if (Number(issueDate.slice(0, 4)) !== series.year) {
        throw new SeriesError('series_year', `A data ${issueDate} não pertence à série ${series.prefix}`);
    }
    // Mesmo segundo é aceite (duas vendas rápidas); recuar não.
    if (series.lastSystemEntry && systemEntryDate < series.lastSystemEntry) {
        throw new SeriesError('clock_backwards', `O relógio do terminal está atrás do último documento (${series.lastSystemEntry}). Acerte a data e a hora antes de vender.`);
    }
    const number = series.nextNumber;
    const fullNumber = formatDocumentNumber(series.prefix, number);
    const grossTotal = money(doc.grossTotal);
    const previousHash = series.lastHash;
    const hash = await signer.sign(canonicalString({ issueDate, systemEntryDate, documentNumber: fullNumber, grossTotal, previousHash }));
    return {
        issued: { seriesId: series.seriesId, number, fullNumber, issueDate, systemEntryDate, grossTotal, previousHash, hash, keyId: signer.keyId },
        series: { ...series, nextNumber: number + 1, lastHash: hash, lastIssueDate: issueDate, lastSystemEntry: systemEntryDate },
    };
}
//# sourceMappingURL=series.js.map